import { Box, Button, Card, CardActions, CardContent, Typography } from '@mui/material'
import React from 'react'
import host from '../../assets/js/Host'
import helpers from '../../assets/js/helper'

export default function CardItem(props) {
    const getUserImage = () => {
        if (props?.creator_images_path) {
            return host + props.creator_images_path
        } else {
            return require('../../assets/img/user.jpg')
        }
    }
    return (
        <Box
            sx={{
                width: '100% !important',
                backgroundColor: '#fff !important',
                boxShadow: '0 0 5px -2px #000 !important',
                borderRadius: '5px !important',
                marginBottom: '5px !important',
                display: 'flex',
                alignItems: 'flex-start',
                padding: '10px',
                flexDirection: 'column',
            }}
        >
            <Box
                sx={{
                    width: '100% !important',
                    display: 'flex',
                    alignItems: 'flex-start',
                }}
            >
                <Box
                    sx={{
                        width: 'fit-content',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                        gap: '5px'
                    }}
                >
                    <img
                        style={{
                            width: '50px',
                            height: '50px',
                            borderRadius: '50%',
                            objectFit: 'center',
                            position: 'relative',
                            border:'2px dotted #da9a9a'
                            // top:'3px'
                        }}
                        src={getUserImage()}
                    />
                    

                </Box>
                <Box
                    sx={{
                        width: '79%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                        gap: '5px',
                        marginLeft:'10px'
                    }}
                >
                    <span style={{ fontSize: '14px', position: 'relative', top: '0' }}>{props?.creator_name}</span>
                    <span style={{ fontSize: '12px', color: 'gray', position: 'relative', top: '-5px' }}>{helpers?.formatDate(props?.created_at)+' '+helpers?.formatTime(props?.created_at)}</span>
                    {/* {props?.updated_by>0&&props?.updater_images_path?<Box>
                
                   </Box>:null} */}
                </Box>
            </Box>
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    gap: '5px',
                    paddingTop:'10px'
                }}
            >
                <span style={{ fontSize: '16px', fontWeight: 'bold' }}>{props?.title}</span>
                <span style={{ fontSize: '14px', color: 'gray',textAlign:'justify' }}>{props?.body}</span>
            </Box>
        </Box>
    )
}
